// extracted by mini-css-extract-plugin
export var pillWrapper = "_j2-0";
export var showOverflow = "_j2-1";